import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { catchError, map, of } from 'rxjs';
import { UltrasonicApiService } from '../services/ultrasonic-api.service';

/**
 * Guard that allows access only to users with a specified testing level or pass an argument to specify the required level (default is 3).
 * Redirects to /forbidden on insufficient privileges.
 */
export function userLevelGuard(level: number = 3): CanActivateFn {
  return () => {
    const msal = inject(MsalService);
    const api = inject(UltrasonicApiService);
    const router = inject(Router);

    const azureId = msal.instance.getActiveAccount()?.localAccountId;

    if (!azureId) {
      return router.createUrlTree(['/forbidden']);
    }

    return api.getUserByAzureId(azureId).pipe(
      map((user) => {
        const userLevel = Number(user.testingLvl ?? 0);
        if (userLevel >= level) {
          return true;
        }
        return router.createUrlTree(['/forbidden']);
      }),
      catchError(() => of(router.createUrlTree(['/forbidden'])))
    );
  };
}
